


















import Vue from 'vue'
import * as R from 'ramda'
import { State } from 'vuex-class'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { CheckboxModel } from '../interfaces/checkbox-model'
import { User } from '@/modules/User/interfaces/user'

@Component({
  components: {
  }
})

export default class ListItemRules extends Vue {
  @Prop({ type: Number, default: 196 }) readonly remainingHeight!: number
  @Prop({ type: Object as () => CheckboxModel }) readonly items!: CheckboxModel
  @Prop({ type: String }) readonly order!: string
  @Prop({ type: Boolean }) readonly ifAsc!: boolean

  @State(state => state.user.me) me!: User

  models: CheckboxModel = {}

  asc: {
    [key: string]: boolean | null
  } = {
    'Policy Name': null,
    'Effective Date': null,
    'Expiration Date': null,
    'Policy Number': null,
    'Status': null
  }

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    'Policy Name': 'POLICY_NAME',
    'Effective Date': 'EFFECTIVE_DATE',
    'Expiration Date': 'EXPIRATION_DATE',
    'Policy Number': 'POLICY_NUMBER',
    'Status': 'POLICY_STATUS'
  }

  orderByActive = ''
  ascActive:boolean | null = false

  list: string[] = []

  @Watch('models', { deep: true })
  onModelsChanged (val: CheckboxModel) {

  }

  @Watch('items', { deep: true })
  onItemsChanged (val: CheckboxModel) {
    this.models = Object.assign({}, this.items)
    this.list = R.keys(this.items)
  }

  async mounted () {
    const { order, orderBy } = this
    this.models = Object.assign({}, this.items)
    this.list = R.keys(this.items)

    if (order) {
      const key = R.keys(orderBy).find(key => orderBy[key] === order)
      if (key) {
        this.asc[key] = this.ifAsc || false
        this.orderByActive = orderBy[key]
        this.ascActive = this.asc[key]
      }
    }
  }

  onCheckboxClick (item: string) {
    this.models[item] = !this.models[item]
    this.onChange()
    this.items[item] = !this.items[item]
  }

  onChangeRadio (item: string) {
    this.orderByActive = this.orderBy[item]
    this.ascActive = this.asc[item]
    this.onChange()
  }

  @Emit('change')
  onChange () {
    // 获得所有已选列表字段、orderBy、asc
    return {
      list: this.models,
      orderBy: this.orderByActive,
      asc: this.ascActive
    }
  }
}
